export enum StatusEnum {
  SCHEDULED = "SCHEDULED",
  BUDGET_APPROVAL = "BUDGET_APPROVAL",
  SCHEDULED_TO_RUN = "SCHEDULED_TO_RUN",
  RUNNING = "RUNNING",
  FINISHED = "FINISHED",
  IN_BILLING = "IN_BILLING",
  CANCELED = "CANCELED",
  DISAPPROVED = "DISAPPROVED"
}
